import { SelectedFileType } from "@/hooks/useFilePicker";
import { logger } from "@/utils/logger";

export const FilesApi = {
  uploadFile: async ({
    presignedUrl,
    file,
  }: {
    presignedUrl: string;
    file: SelectedFileType;
  }) => {
    try {
      const response = await fetch(file.uri);
      const blob = await response.blob();

      const uploadResponse = await fetch(presignedUrl, {
        method: "PUT",
        body: blob,
        headers: {
          "Content-Type": file.mimeType,
        },
      });

      return uploadResponse.ok;
    } catch (error) {
      logger.error({ error, message: "Failed to upload file to storage" });
      return false;
    }
  },
};
